
//login
import { login, forgotPassword, loginResponse, loginClear, refreshToken, otpVerify, resetPassword } from "./action/Login"
import { authCheck, loginCheckResponse} from "./action/Login/loginCheck"
// profile
import { getUpdateProfile } from "./action/ProfilegetApi"
// footer contact details 
import { getFooterdetailsapi } from "./action/Footerdetailsapi"
// faqs
import { getFaqApi, updateFaqStatus, faqstatusResponse } from "./action/Faqsgetapi"
// service
import { getServiceApi, updateServiceStatus, servicestatusResponse } from './action/ServiceApi'
// job
import { getJobApi, updateJobStatus, jobstatusResponse } from "./action/Jobgetapi"
// client
import { getClientApi, updateClientStatus, clientstatusResponse } from "./action/Clientgetapi"
// professional
import { getProfessionalApi, updateProfessionalStatus, professionalstatusResponse } from "./action/Professionalgetapi"
// job tracking
import { getJobTrack, updateJobtrackStatus, jobtrackstatusResponse } from "./action/JobtrackgetApi"
// project tracking
import { getProjectTrack, updateProjecttrackStatus, projecttrackstatusResponse } from "./action/ProjectTrackgetapi"
// review apis
import { getReviewsAll } from "./action/Reviewapi"
// notificaiton apis
import { getNotificationsAll } from "./action/Notigetapi"
// dashboard
import { getAddCardDetail } from './action/cardapi'


export const actionsApi = {
    login, 
    forgotPassword,
    loginClear, 
    authCheck, 
    loginCheckResponse,
    loginResponse,
    refreshToken, 
    otpVerify, 
    resetPassword,
    // profile get api
    getUpdateProfile,
    // footer contact details api
    getFooterdetailsapi,
    // faqs api
    getFaqApi, updateFaqStatus, faqstatusResponse,
    // service api
    getServiceApi, updateServiceStatus, servicestatusResponse,
    // job api
    getJobApi, updateJobStatus, jobstatusResponse,
    // client api
    getClientApi, updateClientStatus, clientstatusResponse,
    // professional
    getProfessionalApi, updateProfessionalStatus, professionalstatusResponse,
    // job tracking
    getJobTrack, updateJobtrackStatus, jobtrackstatusResponse,
    // project tracking
    getProjectTrack, updateProjecttrackStatus, projecttrackstatusResponse,
    // reviews
    getReviewsAll,
    // notificaiton
    getNotificationsAll,
    // dashboard
    getAddCardDetail
}
